/* KneeNova cart — quantity, size swap, remove + undo, promo code.
   Every mutation goes through the Cart AJAX API and then re-renders the section
   through the Section Rendering API, so money formatting, discounts and totals
   always come from Liquid rather than being recomputed here. */
(function(){
  var root = document.querySelector('[data-kn-cart]');
  if (!root) return;

  var sectionId = root.getAttribute('data-section-id');
  var cartUrl = root.getAttribute('data-cart-url') || '/cart';
  var lastRemoved = null;
  var toastTimer = null;

  function announce(msg){
    var live = document.getElementById('kn-cart-live');
    if (live) live.textContent = msg;
  }

  function post(url, body){
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function(res){
      return res.json().then(function(data){
        if (!res.ok) throw new Error(data.description || data.message || 'Cart update failed');
        return data;
      });
    });
  }

  function setHeaderCount(count){
    var link = document.querySelector('.kn-acts a[href$="/cart"]');
    if (!link) return;
    var badge = link.querySelector('.kn-count');
    if (count > 0){
      if (!badge){
        badge = document.createElement('span');
        badge.className = 'kn-count';
        link.appendChild(badge);
      }
      badge.textContent = count;
    } else if (badge){
      badge.remove();
    }
    link.setAttribute('aria-label', count > 0 ? 'Cart, ' + count + ' items' : 'Cart');
  }

  function refresh(){
    return fetch(cartUrl + '?sections=' + encodeURIComponent(sectionId))
      .then(function(res){ return res.json(); })
      .then(function(data){
        var markup = data[sectionId];
        if (!markup) { location.reload(); return; }
        var doc = new DOMParser().parseFromString(markup, 'text/html');
        var fresh = doc.querySelector('[data-kn-cart]');
        var current = document.querySelector('[data-kn-cart]');
        if (fresh && current){
          current.replaceWith(fresh);
          root = fresh;
          bind();
        } else {
          location.reload();
        }
      });
  }

  function busy(line, on){
    if (line) line.classList.toggle('knc-line--busy', !!on);
  }

  /* ---------- quantity ---------- */
  function changeQty(line, key, qty){
    busy(line, true);
    post('/cart/change.js', { id: key, quantity: qty })
      .then(function(cart){
        setHeaderCount(cart.item_count);
        announce('Cart updated. ' + cart.item_count + ' item' + (cart.item_count === 1 ? '' : 's') + ' in your cart.');
        return refresh();
      })
      .catch(function(err){
        busy(line, false);
        announce(err.message);
      });
  }

  /* ---------- remove + undo ---------- */
  function showToast(name){
    var toast = document.getElementById('kn-cart-toast');
    if (!toast) return;
    toast.querySelector('[data-kn-toast-text]').textContent = name + ' removed.';
    toast.hidden = false;
    requestAnimationFrame(function(){ toast.classList.add('is-on'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, 8000);
  }
  function hideToast(){
    var toast = document.getElementById('kn-cart-toast');
    if (!toast) return;
    toast.classList.remove('is-on');
    setTimeout(function(){ toast.hidden = true; }, 300);
    lastRemoved = null;
  }

  function removeLine(line, btn){
    var key = btn.getAttribute('data-line-key');
    lastRemoved = {
      id: btn.getAttribute('data-variant-id'),
      quantity: parseInt(btn.getAttribute('data-qty'), 10) || 1,
      name: btn.getAttribute('data-name') || 'Item'
    };
    busy(line, true);
    post('/cart/change.js', { id: key, quantity: 0 })
      .then(function(cart){
        setHeaderCount(cart.item_count);
        announce(lastRemoved.name + ' removed from your cart.');
        showToast(lastRemoved.name);
        return refresh();
      })
      .catch(function(err){
        busy(line, false);
        lastRemoved = null;
        announce(err.message);
      });
  }

  function undo(){
    if (!lastRemoved) return;
    var item = lastRemoved;
    hideToast();
    post('/cart/add.js', { items: [{ id: item.id, quantity: item.quantity }] })
      .then(function(){ announce(item.name + ' added back to your cart.'); return refresh(); })
      .catch(function(err){ announce(err.message); });
  }

  /* ---------- swap variant (size) ---------- */
  function swapVariant(line, select){
    var oldId = select.getAttribute('data-current-id');
    var newId = select.value;
    var qty = parseInt(select.getAttribute('data-qty'), 10) || 1;
    if (!newId || newId === oldId) return;

    var updates = {};
    updates[oldId] = 0;
    updates[newId] = qty;

    busy(line, true);
    post('/cart/update.js', { updates: updates })
      .then(function(cart){
        setHeaderCount(cart.item_count);
        announce('Option updated.');
        return refresh();
      })
      .catch(function(err){
        busy(line, false);
        select.value = oldId;
        announce(err.message);
      });
  }

  /* ---------- promo ---------- */
  function bindPromo(){
    var form = root.querySelector('[data-kn-promo]');
    if (!form) return;
    var input = form.querySelector('input[name="code"]');
    var apply = form.querySelector('[data-kn-promo-apply]');

    function submit(){
      var code = (input.value || '').trim();
      if (!code) { input.focus(); return; }
      var back = cartUrl + '?promo=' + encodeURIComponent(code);
      location.assign('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(back));
    }

    if (apply) apply.addEventListener('click', submit);
    if (input) input.addEventListener('keydown', function(e){
      if (e.key === 'Enter'){ e.preventDefault(); submit(); }
    });
  }

  /* Shopify applies the code on /discount/CODE and sends us back here. Liquid tells
     us whether a cart-level discount survived, which is the real answer on whether
     the code was valid. Report it once, then strip the param. */
  function reportPromo(){
    var params = new URLSearchParams(location.search);
    var code = params.get('promo');
    if (!code) return;

    var details = root.querySelector('.knc-promo');
    var msg = root.querySelector('[data-kn-promo-msg]');
    var applied = root.getAttribute('data-has-discount') === 'true';

    if (details) details.open = true;
    if (msg){
      msg.setAttribute('data-state', applied ? 'ok' : 'error');
      msg.textContent = applied
        ? 'Code ' + code + ' applied.'
        : 'We could not apply "' + code + '". Check the code or its conditions and try again.';
      announce(msg.textContent);
    }

    params.delete('promo');
    var qs = params.toString();
    history.replaceState(null, '', location.pathname + (qs ? '?' + qs : ''));
  }

  /* ---------- binding ---------- */
  function bind(){
    root.querySelectorAll('[data-kn-step]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var line = btn.closest('.knc-line');
        var input = line.querySelector('[data-kn-qty]');
        var step = parseInt(btn.getAttribute('data-kn-step'), 10);
        var next = (parseInt(input.value, 10) || 1) + step;
        if (next < 1) return;
        changeQty(line, input.getAttribute('data-line-key'), next);
      });
    });

    root.querySelectorAll('[data-kn-qty]').forEach(function(input){
      input.addEventListener('change', function(){
        var line = input.closest('.knc-line');
        var next = parseInt(input.value, 10);
        if (!next || next < 1){ next = 1; input.value = 1; }
        changeQty(line, input.getAttribute('data-line-key'), next);
      });
    });

    root.querySelectorAll('[data-kn-remove]').forEach(function(btn){
      btn.addEventListener('click', function(){ removeLine(btn.closest('.knc-line'), btn); });
    });

    root.querySelectorAll('[data-kn-edit]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!panel) return;
        var open = panel.hidden;
        panel.hidden = !open;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) panel.querySelector('select').focus();
      });
    });

    root.querySelectorAll('[data-kn-variant]').forEach(function(select){
      select.addEventListener('change', function(){ swapVariant(select.closest('.knc-line'), select); });
    });

    bindPromo();
  }

  var undoBtn = document.querySelector('[data-kn-undo]');
  if (undoBtn) undoBtn.addEventListener('click', undo);
  var dismissBtn = document.querySelector('[data-kn-toast-close]');
  if (dismissBtn) dismissBtn.addEventListener('click', hideToast);

  bind();
  reportPromo();
})();
